/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

export type NbNullableInput = string | null | undefined;
export type NbBooleanInput = boolean | NbNullableInput;

export function convertToBoolProperty(val: any): boolean {
  if (typeof val === 'string') {
    val = val.toLowerCase().trim();

    return val === 'true' || val === '';
  }

  return !!val;
}

export function getElementHeight(el) {
  /**
   *
   * TODO: Move helpers in separate common module.
   * TODO: Provide window through di token.
   * */
  const style = window.getComputedStyle(el);
  const marginTop = parseInt(style.getPropertyValue('margin-top'), 10);
  const marginBottom = parseInt(style.getPropertyValue('margin-bottom'), 10);
  return el.offsetHeight + marginTop + marginBottom;
}

export function findValueByKey(key) {
  // Check if localStorage is supported by the browser
  if (typeof localStorage === 'undefined') {
    console.error('localStorage is not supported by your browser.');
    return;
  }

  // Loop through all items in localStorage
  for (let i = 0; i < localStorage.length; i++) {
    // Get the key at index i
    const storedKey = localStorage.key(i);
    try {
      const value = JSON.parse(localStorage.getItem(storedKey));
      // Check if the current key matches the desired key
      if (value[key]) {
        return value[key];
      }
    } catch (error) {}
  }
}

export function findObjectByKeyAndValue(key: string, search: string) {
  // Check if localStorage is supported by the browser
  if (typeof localStorage === 'undefined') {
    console.error('localStorage is not supported by your browser.');
    return;
  }

  // Loop through all items in localStorage
  for (let i = 0; i < localStorage.length; i++) {
    // Get the key at index i
    const storedKey = localStorage.key(i);
    try {
      const value = JSON.parse(localStorage.getItem(storedKey));
      // Check if the current key matches the desired key
      if (value[key] === search) {
        return value;
      }
    } catch (error) {}
  }

  // If key is not found, return null
  return null;
}
